import api from "../../api/cofocusAPI";

async function getResponseData(requestConfig) {
    try {
      const response = await api.REQUEST(requestConfig);
      console.log("@getResponseData response: ", response);
      if (response && response.data && response.data.success) {
        return response.data;
      }
    } catch (error) {
      console.error("error with config: ", requestConfig);
    }
    return null;
}

export const getProfilePreview = async function(UID) {
  if (!UID) {
    throw new Error("Required data not provided for request.");
  }
  return getResponseData({
    url: `/api/users/${UID}/previewdata`,
    method: "get",
    params: { UID },
    withCredentials: true,
  });
};

const CalendarRequests = {
    getProfilePreview,
};

export default CalendarRequests;
